import { render } from "./HCTedelno.vue?vue&type=template&id=28a0b6a2"
import script from "./HCTedelno.vue?vue&type=script&lang=js"
export * from "./HCTedelno.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Express\\北方\\Agent_SYSTEM\\AgentWeb\\Vue\\agentweb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__